import { localStorageKey } from "constants-lib/localStorage"
import { SET_INCIDENTS_DATE } from "constants-lib/actionTypes"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

export function setIncidentsDate(incidentsDate, publishedDate) {
  /* clear values set in chatbot */
  ssrWindow.localStorage.removeItem(localStorageKey.SNAPSHOT_INCIDENT_DATE)
  ssrWindow.localStorage.removeItem(localStorageKey.SNAPSHOT_PUBLISHED_DATE)

  return {
    type: SET_INCIDENTS_DATE,
    payload: {
      incidentsDate,
      publishedDate,
    },
  }
}
